import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedDate, FormattedNumber } from 'react-intl';

import { UserSportStatisticFormat } from '@sorare/core/src/__generated__/globalTypes';

import type { FormattedStatistic_UserSportStatistic } from './__generated__/index.graphql';

type Props = { statistic: FormattedStatistic_UserSportStatistic | null };

export const FormattedStatistic = ({ statistic }: Props) => {
  if (!statistic) {
    return null;
  }

  return (
    <>
      {statistic.format === UserSportStatisticFormat.NUMBER && (
        <FormattedNumber
          value={statistic.value}
          compactDisplay="short"
          notation="compact"
          maximumFractionDigits={1}
        />
      )}
      {statistic.format === UserSportStatisticFormat.TIMESTAMP && (
        <FormattedDate
          value={statistic.value * 1000}
          day="2-digit"
          month="2-digit"
          year="numeric"
        />
      )}
    </>
  );
};

FormattedStatistic.fragments = {
  userSportStatistic: gql`
    fragment FormattedStatistic_UserSportStatistic on UserSportStatistic {
      id
      value
      format
    }
  ` as TypedDocumentNode<FormattedStatistic_UserSportStatistic>,
};
